import { Outlet, useLocation } from 'react-router';
import { SegmentedControl } from '../../ui/SegmentedControl';
import styles from './Drums.module.css';

type View = 'library' | 'kit' | 'groove';

/** Drums: Library · Kit · Groove as a segmented control (SPEC §4). */
export function DrumsLayout() {
  const { pathname, search } = useLocation();
  // Kit and Groove opened from a project stay on that project while you switch between them
  const project = new URLSearchParams(search).get('project');
  const q = project ? `?project=${encodeURIComponent(project)}` : '';
  const view = (pathname.split('/')[2] ?? 'library') as View;
  return (
    <div className={styles.drums}>
      <div className={styles.segments}>
        <SegmentedControl<View>
          label="Drums"
          value={view}
          segments={[
            { value: 'library', label: 'Library', to: `/drums/library${q}` },
            { value: 'kit', label: 'Kit', to: `/drums/kit${q}` },
            { value: 'groove', label: 'Groove', to: `/drums/groove${q}` },
          ]}
        />
      </div>
      <div className={styles.body}>
        <Outlet />
      </div>
    </div>
  );
}
